import { FocusEvent, FocusEventHandler, useState } from 'react'
import Select from 'react-select'
import { Box } from 'theme-ui'
import { noop } from 'utils'
import theme from 'theme'
import { TMATTCourseOptions } from 'types'
import { customSelectStyles } from 'components/Form/styles'
import { ChevronDownIcon } from 'components/Icon'

const DropdownIndicator = () => (
  <Box sx={{ width: 20, height: 20 }}>
    <ChevronDownIcon />
  </Box>
)

export type TMATTEnrollInputProps = {
  id?: string
  name: string
  disabled?: boolean
  options: TMATTCourseOptions[]
  placeholder?: string | undefined
  hasErrors?: boolean
  onChange: (newCourse: TMATTCourseOptions) => void
  onBlur?: FocusEventHandler
  tabIndex?: number
  closeOnSelect?: boolean
  error?: boolean
  'data-cy'?: string
}

export const TMATTEnrollInput = ({
  id,
  name,
  disabled,
  options,
  placeholder,
  hasErrors = false,
  onChange,
  onBlur = noop,
  tabIndex,
  closeOnSelect = true,
  ...props
}: TMATTEnrollInputProps) => {
  const [focused, setFocused] = useState(false)
  const handleBlur = (evt: FocusEvent<HTMLElement>) => {
    const blurEvt = evt as FocusEvent<HTMLInputElement>
    blurEvt.target.name = name
    onBlur(blurEvt)
    setFocused(false)
  }
  return (
    <Box
      id={id}
      data-cy="enroll-options"
      sx={{
        p: '10px',
        boxSizing: 'border-box',
        width: '100%',
        bg: 'oldlace',
        borderRadius: 8,
        boxShadow: hasErrors
          ? '0 0 0 2px #f87e0e'
          : focused
          ? '0 0 0 2px #ffc436'
          : 'none',
        opacity: disabled ? 0.6 : 1,
      }}>
      <Select
        aria-label={`select-${name}`}
        name={name}
        placeholder={placeholder}
        options={options}
        getOptionLabel={(option) => `${option.label}`}
        getOptionValue={(option) => `${option.course}`}
        components={{ DropdownIndicator }}
        styles={customSelectStyles}
        theme={(t) => ({
          ...t,
          colors: {
            ...t.colors,
            primary: theme.colors.primary,
            primary50: theme.colors.darkyellow,
            primary25: theme.colors.oldlace,
          },
        })}
        tabIndex={`${tabIndex}`}
        isDisabled={disabled}
        onChange={onChange}
        onFocus={() => setFocused(true)}
        onBlur={handleBlur}
        isSearchable
      />
    </Box>
  )
}
